import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import UploadDummy from "web/assets/images/UploadDummy.png";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik, Field } from "formik";
import Spinner from "web/components/Spinner";
import Button from "web/components/Button";
import YesNoModal from "web/components/YesNoModal";
import Breadcrumb from "web/components/Breadcrumb";
import RequestDateModal from "../PostLoad/RequestDateModal";
import TooltipMaterial from "@material-ui/core/Tooltip";
import { Tooltip } from "reactstrap";
import MaterialTooltip from "@material-ui/core/Tooltip";
import information from "web/assets/images/informationIcon.png";
import { Helmet } from "react-helmet";
import UploadSpecification from "web/components/UploadSpecification";
import TextInput from "web/components/form-elements/TextInput";
import TextArea from "web/components/form-elements/TextArea";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import NumberInput from "web/components/form-elements/NumberInput";
import Select from "web/components/form-elements/Select";
import MultiSelect from "web/components/form-elements/MultiSelect";
import DatePicker from "web/components/form-elements/DatePicker";
import Layout from "web/components/Layout";
import PalletsSidebar from "web/components/PalletsSidebar";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import RadioButton from "web/components/form-elements/RadioButton";
import { createInventoryApi, inventoryUpdate, postInventoryId, postInventorySearchById, getInventorydetailsById } from "redux/actions/postInventory";
import { getLocationDetails, getCommunityGroupsApi, uploadSpec, } from "redux/actions/postLoad";
import { INITIAL_STATE, getDeliveryTimeArr, getDeliveryAvailableArr, getVehiclePreferences, getSellingArrInv, getBidArrInv, getPostMethodArrInv, getRecurrencePostInv } from '../constants'
import AlertModal from "web/components/AlertModal";
import OkCancelAlertModal from "web/components/OkCancelAlertModal";
import styled from "styled-components";
import RightArrow from "web/assets/images/right-arrow-sell.png";
import { getPostInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/postInventoryUtils";
import LocationDetails from '../LocationDetails'
import PalletSpecDetails from "../PalletSpecDetails";
import styles from "./postInventory.module.scss";
import { fetchLanguageContentNew } from "redux/actions/language";

const PostInventory = (props, { isOpen, toggle }) => {
  const dispatch = useDispatch();
  let history = useHistory(); const token = localStorage.getItem("token");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.inventoryPayload);

  const isBroker = localStorage.getItem('brokerAccount')

  const [yesNoActive, setYesNoActive] = useState(false);
  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  const [activeSearch, setActiveSearch] = useState();
  const [palletImagesArr, setPaletImagesArr] = useState();
  const [uploadImageArr, setUploadPalletImageArr] = useState();
  let uploadPalletImageArr = [];

  const [uploadImageStage, setUploadImage] = useState();
  // If the user has not selected any image, check the spec file list to see if the default image is present. If it exists, add it.
  const [defaultPostImage, setDefaultPostImage] = useState();


  const [recurrenceTitle, setRecurrenceTitle] = useState("");
  const [recurrenceFlag, setRecurrenceFlag] = useState(0);
  const [recurrenceObjState, setRecurrenceStateObj] = useState(INITIAL_STATE);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");

  const [requestDateModal, setRequestDateModal] = useState(false);
  const requestDateToggleModal = () => setRequestDateModal(!requestDateModal);

  const [postLoadData, setPostLoadData] = useState("");
  const [okCancelModal, setOkCancelModal] = useState(false);
  const [okCancelModalContent, setOkCancelModalContent] = useState("");
  const toggleOkCancelModal = () => setOkCancelModal(!okCancelModal);

  const [tooltipBidAccept, setTooltipBidAccept] = useState(false);
  const [tooltipOpenOne, setTooltipOpenOne] = useState(false);
  const [tooltipLeadTime, setTooltipLeadTime] = useState(false);
  const [tooltipOpenTwo, setTooltipOpenTwo] = useState(false);
  const [tooltipOpenDesired, setTooltipOpenDesired] = useState(false);
  const [tooltipOpenCpu, setTooltipOpenCpu] = useState(false);
  const [tooltipBidCloseDate, settooltipBidCloseDate] = useState(false);
  const toggleModal = () => setModal(!modal);
  let title = "";
  const [loadSuccessState, setLoadSuccessState] = useState(false);
  const [multiSelectVal, setMultiSelectVal] = useState([]);

  const [communityGroups, setCommunityGroups] = useState([])
  const [palletSpecFilesData, setPalletSpecFilesData] = useState()
  const [pageLoading, setPageLoading] = useState(false)

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  const [pageLanguageNeedContents, setPageLanguageNeedContents] = useState();
  useEffect(() => {
    if (languageContentNew?.Sell_Arrow_PostInventory_Page) setPageLanguageContents(languageContentNew.Sell_Arrow_PostInventory_Page);
    if (languageContentNew?.Buy_Arrow_PostLoad_Page) setPageLanguageNeedContents(languageContentNew.Buy_Arrow_PostLoad_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  // fetching the required constants for the component
  let fileArr = [];
  const deliveryTime = getDeliveryTimeArr(pageLanguageContents)
  const deliveryAvailableArr = getDeliveryAvailableArr(pageLanguageContents)
  const vehiclePreferences = getVehiclePreferences(pageLanguageContents)
  const sellingArr = getSellingArrInv(pageLanguageContents)
  const bidArr = getBidArrInv(pageLanguageContents)

  const postMethodArr = getPostMethodArrInv(pageLanguageContents)
  const recurrencePost = getRecurrencePostInv(pageLanguageContents)

  useEffect(() => {
    fetchPreReqData()
    window.scrollTo(0, 0);

    let obj = {
      type: "PostLoad",
      activePage: "PostLoad",
      activeSearch: "Dashboard",
      expanded: 'panel1'
    }
    dispatch({ type: 'POST_LOAD_URL', payload: obj })
  }, []);

  const fetchPreReqData = async () => {
    // api response data is stored in redux and used, dont delete
    let locationResponse = await dispatch(getLocationDetails(token))
    let communityGroupResponse = await dispatch(getCommunityGroupsApi(token, localStorage.getItem('authId')))
    if (communityGroupResponse.success) {
      let commGroups = communityGroupResponse?.data?.commDetails?.map(data => ({ label: data.commGroupName, value: data.id }))
      setCommunityGroups(commGroups)
    } else {
      if (communityGroupResponse.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  const [pageId, setPageId] = useState("");
  const [myPostType, setMyPostType] = useState();
  const [editResponse, setEditResponse] = useState("");
  const [activePage, setActivePage] = useState();
  const [expanded, expandedState] = useState();

  useEffect(() => {
    const { location } = props;

    setActivePage((urlObject && urlObject.activePage) || 'PostInventory');
    setActiveSearch((urlObject && urlObject.activeSearch) || 'Dashboard');
    expandedState((urlObject && urlObject.expanded) || 'panel2');

    if (!localStorage.getItem("token")) {
      history.push("/sign-in");
      window.location.reload(false);
    } else {
      if (urlObject && urlObject.postType && urlObject.id) {
        setMyPostType(urlObject.postType);
        editPostFun(urlObject.id);
        setPageId(urlObject.id);
      } else {
        setEditResponse();
      }
    }
  }, []);

  const editPostFun = async (id) => {
    let obj = {
      type: "PostLoad",
      activePage: "PostLoad",
      expanded: 'panel1'
    }
    dispatch({ type: 'POST_LOAD_URL', payload: obj })

    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      const data = {
        authId: localStorage.getItem('authId'),
        inventoryId: id
      }
      const response = await dispatch(getInventorydetailsById(data, token));
      // let response = await dispatch(postInventoryId(id, token));
      if (response?.success) {
        setRecurrenceFlag(0);

        if (response?.data?.postImageFiles && response?.data?.postImageFiles?.length !== 0) {
          uploadPalletImageArr = response?.data?.postImageFiles[0]
          setUploadImage(response?.data?.postImageFiles[0]?.fileName)
        }
        if (response?.data?.postPreferences?.postingMethod === "GROUP") {
          let communityGroupResponse = await dispatch(getCommunityGroupsApi(token, localStorage.getItem('authId')))
          if (communityGroupResponse?.success) {
            let commGroups = communityGroupResponse?.data?.commDetails?.map(data => ({ label: data.commGroupName, value: data.id }))
            setCommunityGroups(commGroups)

            let userSelectedGroups = response?.data?.postPreferences?.groupIdsList
            let userSelectedGroupsValue
            if (userSelectedGroups && userSelectedGroups.length) {
              userSelectedGroupsValue = commGroups.filter(item => userSelectedGroups.includes(item.value));
            }
            if (userSelectedGroupsValue && userSelectedGroupsValue.length) setMultiSelectVal(userSelectedGroupsValue)
          }
        }
        setEditResponse(response?.data);
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const handleSubmit = async (props, flag, specFileUpdatedValue) => {
    const { submitForm, isValid, validateForm, setTouched } = props;

    if (props.values.isSizeAvailable && props.values.size === '') {
      setModalContent("Size is required.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values.isMoistureAvailable && props.values.moisture === '') {
      setModalContent("Moisture is required.");
      setModalLink("");
      toggleModal();
      return
    } else if (props.values.isGradeAvailable && props.values.grade === '') {
      setModalContent("Grade is required.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values?.length !== '' && props.values?.length < 1) {
      setModalContent("Length should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }
    if (props.values?.width !== '' && props.values?.width < 1) {
      setModalContent("Width should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }
    if (props.values?.height !== '' && props.values?.height < 1) {
      setModalContent("Height should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values.postingPlacePreference === "GROUP" && props.values.postingMethod.length === 0) {
      setModalContent('Select atleast one community group to post.');
      setModalLink("");
      toggleModal();
      return;
    }

    let vehiclePref = []
    if (props.values.vehiclePreferences0) vehiclePref.push("FLAT_BED")
    if (props.values.vehiclePreferences1) vehiclePref.push("VAN")
    if (props.values.vehiclePreferences2) vehiclePref.push("STRAIGHT")
    if (vehiclePref.length === 0 && props.values.isDeliveryAvailable === "true") {
      setModalContent("Equipment required for delivery is a mandatory field.");
      setModalLink("");
      toggleModal();
      return
    }

    let setBasePrice = props.values.basePrice
    if (props.values.basePrice.toString().charAt(0) === "$") {
      setBasePrice = props.values.basePrice.replace('$', '')
    }

    let desiredPrice = props.values.desiredPrice
    if (props.values.desiredPrice.toString().charAt(0) === "$") {
      desiredPrice = props.values.desiredPrice.replace('$', '')
    }

    let cpuPrice = props.values.cpuPrice
    if (props.values.cpuPrice.toString().charAt(0) === "$") {
      cpuPrice = props.values.cpuPrice.replace('$', '')
    }

    // buy now and buy now pickup prices has to greater than the minimum delivered price, or else an confirmation has to be asked
    if (!((props.values.isDeliveryAvailable === "true" &&
      (desiredPrice === "" || parseFloat(desiredPrice) === 0 || parseFloat(setBasePrice) < parseFloat(desiredPrice)) &&
      (cpuPrice === "" || parseFloat(cpuPrice) === 0 || parseFloat(setBasePrice) < parseFloat(cpuPrice))) ||
      (props.values.isDeliveryAvailable === "false" && (cpuPrice === "" || parseFloat(cpuPrice) === 0 || parseFloat(setBasePrice) < parseFloat(cpuPrice))) ||
      flag)) {
      setYesNoModalContent("The buy now price(s) are less than the target price. Do you wish to continue?");
      yesNoToggleModal();
      return;
    }

    if (props.values.bidAcceptanceMethod === "ABOVE_TARGET_THRESHOLD" && !setBasePrice) {
      setModalContent("Minimum delivered price is required.");
      setModalLink("");
      toggleModal();
      return;
    } else if (props.values.bidAcceptanceMethod === "APPROVE_AND_ACCEPT" && props.values.costCheckBox && !setBasePrice) {
      setModalContent("Minimum delivered price is required.");
      setModalLink("");
      toggleModal();
      return;
    }

    // conditional pallet type field
    let palletTypeValue
    if (props.values.palletType && props.values.palletType !== '') palletTypeValue = props.values.palletType
    else palletTypeValue = 'CUSTOM'

    //condition
    let conditionValue
    if (props.values.conditionRadioValue === 'recycled') conditionValue = ['RECYCLED']
    else if (props.values.conditionRadioValue === 'newCondition') conditionValue = ['NEW']
    else if (props.values.conditionRadioValue === 'combo') conditionValue = ['COMBO']
    else if (props.values.conditionRadioValue === 'cores') conditionValue = ['CORES']

    // calculate bidding close time form the date and time value we have
    let biddingCloseDateTime
    let dateTimevalue = `${props.values.bidCloseTime} ${props.values.postLoadBidCloseTime}`
    const dateTime = moment(dateTimevalue, 'MM-DD-YYYY HH:mm')
    // const dateTime = moment(dateTimevalue, 'YYYY-MM-DD HH:mm')
    // biddingCloseDateTime = dateTime.valueOf() / 1000;
    biddingCloseDateTime = moment(dateTime).format('YYYY-MM-DDTHH:mm')

    // object for post/order recurrence if chosen
    let recurrencePayloadObject
    if (recurrenceFlag === 1 || recurrenceFlag === 2) {
      recurrencePayloadObject = {
        pattern: {
          type: props.values.type,
          interval: props.values.interval,
          dayOfWeek: props?.values?.dayOfWeek ? props?.values?.dayOfWeek : null,
          daysOfWeek: props.values.daysOfWeek,
          dayOfMonth: props.values.dayOfMonth,
          index: props.values.index,
        },
        range: {
          start: moment(props.values.start).format('YYYY-MM-DD'),
          endBy: moment(props.values.endBy).format('YYYY-MM-DD'),
          endAfterOccurrences: null,
        },
      }
    }

    let data = {
      authId: localStorage.getItem('authId'),
      locationId: props.values.locationId ? props.values.locationId : localStorage.getItem('locationId'),
      shippingAddress: {
        locationName: props.values.shipperName,
        address1: props.values.line1,
        address2: props.values.line2,
        city: props.values.city,
        state: props.values.state,
        zipCode: props.values.zip,
      },
      postTitle: props.values.title,
      postImageFiles: uploadPalletImageArr && uploadPalletImageArr.length !== 0 ? uploadPalletImageArr :
        uploadImageArr ? uploadImageArr :
          defaultPostImage ? [defaultPostImage] :
            (uploadImageStage && editResponse?.postImageFiles) ? editResponse?.postImageFiles : null,
      palletDetails: {
        material: props.values.materialRadioValue?.toUpperCase(),
        condition: conditionValue,
        palletType: palletTypeValue?.toUpperCase(),
        moisture: props.values.moisture,
        size: props.values.size,
        grade: props.values.grade,
        length: props.values.length,
        width: props.values.width,
        height: props.values.height,
        heatTreared: props.values.heatTreated,
      },
      specificationFiles: specFileUpdatedValue ? specFileUpdatedValue :
        palletSpecFilesData ? palletSpecFilesData : null,
      shippingMode: props.values.isDeliveryAvailable === 'true' ? "DELIVERY" : 'PICKUP',
      vehiclePreferences: props.values.isDeliveryAvailable === 'true' ? vehiclePref : null,
      distanceWillingToTravel: (props.values.isDeliveryAvailable && props.values?.distanceWillingToTravel !== '') ? parseInt(props.values?.distanceWillingToTravel) : null,
      deliveryLeadTime: (props.values.deliveryTime && props.values.deliveryTime !== '') ? parseInt(props.values.deliveryTime) : '',

      postRecurrence: recurrenceFlag === 1 ? recurrencePayloadObject : null,
      lotDetails: {
        totLots: props.values.lots,
        qtyPerLot: props.values.quantityPerLot,
        totalQty: props.values.totalQuantity,
        originalQty: editResponse?.lotDetails?.originalQty && props.values.quantityMaxValue === 540 ?
          props.values.materialRadioValue === "plastic" || props.values.materialRadioValue === "other" ? props.values.quantityMaxValue
            : editResponse?.lotDetails?.originalQty : props.values.quantityMaxValue,
        lotPostingOption: props.values?.lotPostingOption === 'SplitByLot' ? "MULTIPLE" : 'SINGLE'
      },
      allowAltOffer: props.values?.lotsCheckBox || false,

      minDeliveredPrice: (props.values.basePrice && props.values.basePrice !== '') ? parseFloat(setBasePrice) : null,
      buyNowDeliveredPrice: (props.values.desiredPrice && props.values.desiredPrice !== '') ? parseFloat(desiredPrice) : null,
      buyNowPickupPrice: (props.values.cpuPrice && props.values.cpuPrice !== '') ? parseFloat(cpuPrice) : null,

      displayCostToMarket: props.values?.costCheckBox || false,
      postPreferences: {
        acceptanceMethod: props.values?.bidAcceptanceMethod === 'APPROVE_AND_ACCEPT' ? "MANUAL" : 'AUTOMATIC',
        bidCloseTime: biddingCloseDateTime,
        postingMethod: props.values.postingPlacePreference === 'MARKET' ? "MARKET" : "GROUP",
        groupIdsList: props.values.postingPlacePreference === 'GROUP' ? props.values.postingMethod?.map(data => data.value) : null
      },
      comments: props.values.description
    }
    // conditionally adding if hardwood/softwood is selected
    if (conditionValue?.includes('NEW') && props.values?.hardOrSoftWood !== '') {
      data.palletDetails.newConditionType = (props.values?.hardOrSoftWood === 'New - Hardwood') ? 'HARDWOOD' : 'SOFTWOOD'
    }
    // additional payload if it is a broker account
    if (isBroker === 'brokerAc') {
      let brokerOfficeHourStartValue = props.values.brokerOperationStartTime
      let brokerOfficeHourEndValue = props.values.brokerOperationEndTime

      const fromTimeValue = parseInt(brokerOfficeHourStartValue?.replace(":", ""));
      const toTimeValue = parseInt(brokerOfficeHourEndValue?.replace(":", ""));
      if (!(toTimeValue > fromTimeValue)) {
        setModalContent("Location's operation time is invalid.")
        setModalLink("");
        toggleModal();
        return
      } else if (!props.values?.brokerOperationDays || props.values?.brokerOperationDays?.length === 0) {
        setModalContent("Please select location's operation days.")
        setModalLink("");
        toggleModal();
        return
      } else {
        data.shippingAddress.locationDaysOfOperations = props.values.brokerOperationDays
        data.shippingAddress.locationOfficeHourStart = props.values.brokerOperationStartTime
        data.shippingAddress.locationOfficeHourEnd = props.values.brokerOperationEndTime
      }
    }
    let response;
    if (editResponse) {
      data.id = editResponse?.id
      response = await dispatch(inventoryUpdate(data, token))
    } else {
      response = await dispatch(createInventoryApi(data, token))
    }

    if (response?.success) {
      setLoadSuccessState(true);
      setModalContent(response?.data?.msg)
      setModalLink("");
      toggleModal();
    } else {
      setLoadSuccessState(false);
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const postInventoryClick = async (props) => {
    // palletSpecFilesData should be in orignalfilename, filename format
    // if it is already converted in that format we can proceed with the create api
    // but if it is in uploaded file format then call the s3 bucket upload api and get the response after that proceed with create api
    // if no data is present show error message
    if (palletSpecFilesData && palletSpecFilesData?.length > 0 && palletSpecFilesData[0].orignalFileName) {
      if (palletImagesArr) {
        uploadPalletImageArr = []
        uploadImageApi(props, palletSpecFilesData)
      } else {
        handleSubmit(props, false, palletSpecFilesData);
      }
    } else {
      if (props.values.materialRadioValue === "wood" && (props.values.conditionRadioValue === 'recycled' || props.values.conditionRadioValue === 'cores') && props.values.palletType === "stringer" && props.values.size === "48x40" && props.values.grade === '') {
        setModalContent("Grade is required.");
        setModalLink("");
        toggleModal();
        return
      } else {
        if ((!palletSpecFilesData || palletSpecFilesData?.length === 0)) {
          setModalContent("Please upload the specification file.");
          setModalLink("");
          toggleModal();
          return
        } else {
          setPageLoading(true)
          let formData = new FormData();
          palletSpecFilesData.map((data) => formData.append("uploadSpecification", data))
          let response = await dispatch(uploadSpec(formData, ''));
          if (response.status === "SUCCESS") {
            let updatedSpecFilesData = response.payload
            setPalletSpecFilesData(response.payload)
            if (palletImagesArr) {
              uploadPalletImageArr = []
              uploadImageApi(props, updatedSpecFilesData)
            } else {
              handleSubmit(props, false, updatedSpecFilesData);
            }
          } else {
            setPageLoading(false)
            setModalContent("Specification file upload failed, please try again.");
            setModalLink("");
            toggleModal();
            return
          }
        }
      }
    }
  };

  const generatePdfDocument = async (imagePath) => {
    const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    window.open(fileUrl);
  };

  const productImage = () => {
    if (defaultPostImage?.fileName || uploadImageStage) {
      return (
        <div className="row">
          <TooltipMaterial
            placement="top"
            arrow
            title={defaultPostImage?.fileName || uploadImageStage}
            enterTouchDelay={0}
          >
            <UploadSpec
              className="upload col-12"
              onClick={() => {
                generatePdfDocument(defaultPostImage?.fileName || uploadImageStage)
              }}
            >
              <img
                src={UploadDummy}
                alt="upload Dummy"
              />
              <span style={{ fontSize: '13px', marginTop: '7px', cursor: 'pointer' }}>{defaultPostImage?.fileName || uploadImageStage}</span>
            </UploadSpec>
          </TooltipMaterial>
        </div>
      );
    }
  }

  const postInventoryFun = () => {
    return (
      <>
        {editResponse !== "" && (
          <Formik
            initialValues={getPostInitialValues(editResponse, multiSelectVal)}
            validationSchema={VALIDATION_SCHEMA(pageLanguageContents)}
            enableReinitialize={true}
            onSubmit={(values) => { }}
          >
            {(props) => {
              const { errors, setFieldValue } = props;
              return (
                <>
                  <Form>
                    <SectionWrapper className="pt-3">
                      <LocationDetails formikProps={props} pageLanguageContents={pageLanguageContents} urlObject={urlObject} postedNeedEditValues={editResponse} page={'createInv'} />
                    </SectionWrapper>

                    <SectionWrapper className="pt-3" style={{ "padding-bottom": "18px" }}>
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_PostDetails[0]?.Title}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="mb-2">
                            <p className="mt-0">
                              {pageLanguageContents?.Arrow_PostDetails[1]?.PostTitle}
                              <span className={styles.star}>&#42;</span>
                            </p>
                          </div>
                          <div>
                            <TextInput
                              name="title"
                              placeholder={pageLanguageContents?.Arrow_PostDetails[2]?.Title_Placeholder}
                              showErrorMessages={true}
                            />
                          </div>
                        </div>
                        <PostLoaduploadWrapper className="col-md-6 col-sm-12">
                          {/* <div className="mb-2 d-none d-md-block">
                            <p className="mt-0">&nbsp;</p>
                          </div> */}
                          <div className="mb-2">
                            <p className="mt-0 d-none d-md-block">
                              &nbsp;
                            </p>
                          </div>
                          <div className="stepUpload">
                            <UploadSpecification
                              acceptFiles="image/png,image/jpeg,image/gif"
                              name="uploadPalletInventoryImg"
                              props={props}
                              ProfileName=""
                              CompanyName=""
                              pageType=""
                              fileArr={fileArr}
                              imageLoadCallBack={(imageArr) => {
                                setUploadImage();
                                setDefaultPostImage()
                                setPaletImagesArr(imageArr);
                              }}
                              callBackFun={(imageArr) => {
                                setPaletImagesArr(imageArr);
                              }}
                            />
                            {(defaultPostImage || uploadImageStage) && productImage()}
                          </div>
                        </PostLoaduploadWrapper>
                      </div>

                      <PalletSpecWrapper>
                        {/* <PalletSpecDetails formikValues={props} setPalletSpecFilesData={data => setPalletSpecFilesData(data)} /> */}
                        <PalletSpecDetails
                          formikValues={props}
                          editResponse={editResponse}
                          setPalletSpecFilesData={data => setPalletSpecFilesData(data)}
                          defaultPostImageCallBack={imgName => {
                            if (!palletImagesArr) {
                              setUploadImage()
                              if (imgName) setDefaultPostImage({ orignalFileName: imgName, fileName: imgName })
                              else setDefaultPostImage()
                            }
                          }}
                        />
                      </PalletSpecWrapper>

                    </SectionWrapper>
                    <SectionWrapper className="pt-3" style={{ "padding-bottom": "25px" }}>
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_Delivery_Requirement[0]?.Title}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      <div className="row">
                        <div className="col-12">
                          <div className="my-2">
                            <p>{pageLanguageContents?.Arrow_Delivery_Requirement[1]?.Delivery_Available}</p>
                          </div>
                          <div className="row">
                            {deliveryAvailableArr?.map((value, index) => (
                              <div
                                className={`${styles.field} col-md-4`}
                                key={index}
                              >
                                <Field
                                  component={RadioButton}
                                  name="isDeliveryAvailable"
                                  id={value.value}
                                  defaultValue={deliveryAvailableArr[0].value}
                                  onSelect={(e) => {
                                    if (e.target.value === "false") {
                                      setFieldValue("desiredPrice", "");
                                    }
                                  }}
                                  label={value.label}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {props.values?.isDeliveryAvailable === 'true' && (
                        <>
                          <div className="row">
                            <div className="col-12">
                              <div className="mt-2 mb-0">
                                <p className="mb-0">
                                  {pageLanguageContents?.Arrow_Delivery_Requirement[4]?.Delivery_Equipment}
                                  <span className={styles.star}>&#42;</span>
                                </p>
                              </div>
                              <div className="row">
                                <div className="checkbox-wrapper col-md-12">
                                  <div className="row">
                                    {vehiclePreferences.map((value, i) => (
                                      <div className="col-md-4">
                                        <CheckboxInput
                                          name={"vehiclePreferences" + i}
                                          label={vehiclePreferences[i]}
                                          handleSelect={(val, label, flag) => { }}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div>
                            <div className="row">
                              <div className="col-sm-6 mb-7">
                                <div className="my-2">
                                  <p>{pageLanguageContents?.Arrow_Delivery_Requirement[8]?.Distanceto_Travel}</p>
                                </div>
                                <div className="app-input-text">
                                  <NumberInput
                                    name="distanceWillingToTravel"
                                    placeholder={pageLanguageContents?.Arrow_Delivery_Requirement[9]?.Distanceto_Travel_Placeholder}
                                    showErrorMessages={true}
                                  />
                                </div>
                              </div>

                              <div className="col-sm-6 mb-7">
                                <div className="my-2" name="Delivery Lead Time">
                                  <p>
                                    Delivery Lead Time (Biz Days, M-F)
                                    <span className={styles.star}>&#42;</span>
                                    <>
                                      <img
                                        id="TooltipLeadTime"
                                        src={information}
                                        alt="information"
                                        style={{
                                          paddingLeft: "5px",
                                          position: "relative",
                                          top: "-1px",
                                        }}
                                      />
                                      <Tooltip
                                        placement="right"
                                        isOpen={tooltipLeadTime}
                                        target="TooltipLeadTime"
                                        toggle={() =>
                                          setTooltipLeadTime(!tooltipLeadTime)
                                        }
                                      >
                                        <InfoTitleText>Lead time selection will dictate the first available pickup or delivery date that a buyer can choose when making an offer. Lead time is in business days, M-F.</InfoTitleText>
                                      </Tooltip>
                                    </>
                                  </p>
                                </div>
                                <div className="app-input-text">
                                  <Select
                                    name="deliveryTime"
                                    data={deliveryTime}
                                    placeholder={pageLanguageContents?.Arrow_Delivery_Requirement[11]?.Lead_Time_Placeholder}
                                    searchable={false}
                                    onChangeHandler={(data) => { }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {props.values?.isDeliveryAvailable === 'false' && (
                        <div className="row">
                          <div className="col-sm-6 mb-7">
                            <div className="my-2">
                              <p>{pageLanguageContents?.Arrow_Delivery_Requirement[12]?.Lead_TimeHrs}<span className={styles.star}>&#42;</span></p>
                            </div>
                            <div className="app-input-text" name="Lead Time">
                              <Select
                                name="deliveryTime"
                                data={deliveryTime}
                                placeholder={pageLanguageContents?.Arrow_Delivery_Requirement[11]?.Lead_Time_Placeholder}
                                searchable={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </SectionWrapper>
                    <SectionWrapper className="pt-3">
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_Price[0]?.Title}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      <div className="row">
                        <div className="col-md-4 col-sm-12 mb-7">
                          <div className="mb-2">
                            <p className="mt-0">
                              {pageLanguageContents?.Arrow_Price[1]?.Lot}
                              <span className={styles.star}>&#42;</span>
                            </p>
                          </div>
                          <div>
                            <NumberInput
                              name="lots"
                              placeholder={pageLanguageContents?.Arrow_Price[1]?.Lot}
                              maxLength={4}
                              decimalScale={0}
                              disabled={editResponse ? true : false}
                              onChangeHandler={(value) => {
                                if (props.values.quantityPerLot > 0 && parseInt(value) > 0) {
                                  setFieldValue('totalQuantity', (props.values.quantityPerLot * parseInt(value)))
                                } else {
                                  setFieldValue('totalQuantity', '')
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className={`${styles.edit} col-md-4 col-sm-12 mb-7`}>
                          <div className="mb-2">
                            <p className="mt-0">
                              <p className="mt-0">
                                {pageLanguageContents?.Arrow_Price[2]?.Quantity}
                              </p>{" "}
                            </p>
                          </div>
                          <div>
                            <NumberInput
                              name="quantityPerLot"
                              placeholder=""
                              maxLength={5}
                              decimalScale={0}
                              quantityLotsMaxValue={editResponse?.lotDetails?.originalQty && props.values.quantityMaxValue === 540 ?
                                props.values.materialRadioValue === "plastic" || props.values.materialRadioValue === "other" ? props.values.quantityMaxValue
                                  : editResponse?.lotDetails?.originalQty : props.values.quantityMaxValue}
                              onChangeHandler={(lotsValue) => {
                                if (props.values.lots > 0 && parseInt(lotsValue) > 0) {
                                  setFieldValue('totalQuantity', (props.values.lots * parseInt(lotsValue)))
                                } else {
                                  setFieldValue('totalQuantity', '')
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className={`${styles.Qty} col-md-4 col-sm-12 mb-7`}>
                          <div className="mb-2">
                            <p className="mt-0">
                              <p className="mt-0">
                                {pageLanguageContents?.Arrow_Price[3]?.Total_Quantity}
                              </p>{" "}
                            </p>
                          </div>
                          <NumberInput
                            name="totalQuantity"
                            placeholder=""
                            disabled={true}
                            showErrorMessages={true}
                          />
                        </div>
                      </div>

                      {(props.values?.lots && props.values.lots > 1) && (
                        <div className="row">
                          <div className="col-12 mb-7">
                            <div className="my-2">
                              <p>
                                {pageLanguageContents?.Arrow_Price[4]?.LotsSell}
                              </p>
                            </div>
                            <div className="row">
                              {sellingArr?.map((value, index) => (
                                <div
                                  className={`${styles.field} col-md-6`}
                                  key={index}
                                >
                                  <Field
                                    component={RadioButton}
                                    // name="lotPostingOption"
                                    id={value.value}
                                    name={(editResponse && index === 0) ? 'postingRadioDisable' : 'lotPostingOption'}
                                    disabled={editResponse ? true : false}
                                    defaultValue={sellingArr[0].value}
                                    onSelect={(e) => { }}
                                    label={value.label}
                                  />
                                  {index === 0 ? (
                                    <>
                                      <img
                                        id="TooltipOne"
                                        alt="information"
                                        src={information}
                                        style={{
                                          paddingLeft: "5px",
                                          position: "relative",
                                          top: "-1px",
                                        }}
                                      />
                                      <Tooltip
                                        placement="right"
                                        isOpen={tooltipOpenOne}
                                        target="TooltipOne"
                                        toggle={() =>
                                          setTooltipOpenOne(!tooltipOpenOne)
                                        }
                                      >
                                        <InfoTitleText style={{ padding: "2px" }}>{pageLanguageContents?.Arrow_Price[6]?.LotsSell_OP1_icon}</InfoTitleText>
                                      </Tooltip>
                                    </>
                                  ) : (
                                    <>
                                      <img
                                        id="TooltipTwo"
                                        src={information}
                                        alt="information"
                                        style={{
                                          paddingLeft: "5px",
                                          position: "relative",
                                          top: "-1px",
                                        }}
                                      />
                                      <Tooltip
                                        placement="right"
                                        isOpen={tooltipOpenTwo}
                                        target="TooltipTwo"
                                        toggle={() =>
                                          setTooltipOpenTwo(!tooltipOpenTwo)
                                        }
                                      >
                                        <InfoTitleText style={{ padding: "2px" }}>{pageLanguageContents?.Arrow_Price[8]?.LotsSell_OP2_icon}</InfoTitleText>
                                      </Tooltip>
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-12 mb-15">
                          <div className={styles.field}>
                            <CheckboxInput
                              name="lotsCheckBox"
                              label='Allow users to make offers for a quantity that is less than the full amount posted, or choose an alternate mode.'
                              handleSelect={(e) => {
                                if (e !== true) {
                                  setFieldValue('bidAcceptanceMethod', 'APPROVE_AND_ACCEPT')
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="my-2">
                            <p className={`mb-0 ${styles.lineHeight14}`} style={{ minHeight: '20px' }}>
                              {props.values?.isDeliveryAvailable === 'true' ? pageLanguageContents?.Arrow_Price[10]?.MinPrice : pageLanguageContents?.Arrow_Price[12]?.MinPricePick}
                            </p>
                            {props.values.bidAcceptanceMethod === "APPROVE_AND_ACCEPT" && props.values.costCheckBox && <span className="star">* </span>}
                            {props.values.bidAcceptanceMethod === "ABOVE_TARGET_THRESHOLD" && <span className="star">* </span>}
                            <small>{pageLanguageContents?.Arrow_Price[11]?.PerPallet}</small>
                          </div>
                          <div className={styles.field}>
                            <NumberInput
                              name="basePrice"
                              prefix={"$"}
                              placeholder="$ 0.00"
                              decimalScale={2}
                              maxLength={8}
                              decimalSeparator=","
                              fixedDecimalScale
                              thousandSeparator={true}
                            />
                          </div>
                        </div>
                        {props.values?.isDeliveryAvailable === 'true' && (
                          <div className="col-md-4 col-sm-6">
                            <div className="my-2">
                              <p className={`mb-0 ${styles.lineHeight14}`}>
                                {pageLanguageContents?.Arrow_Price[14]?.DeliveryPrice}
                                <>
                                  <img
                                    id="TooltipDesired"
                                    src={information}
                                    alt="information"
                                    style={{
                                      paddingLeft: "5px", position: "relative", top: "-1px",
                                    }}
                                  />
                                  <Tooltip
                                    placement="right"
                                    isOpen={tooltipOpenDesired}
                                    target="TooltipDesired"
                                    toggle={() => setTooltipOpenDesired(!tooltipOpenDesired)}
                                  >
                                    <InfoTitleText> If you choose to utilize the buy now feature, you are required to sell your pallets to the buyer that made the buy now offer. When a buy now offer is received, you will be notified by email and will have two business hours to accept. Your post will be closed on the marketplace and all other offers will be removed.</InfoTitleText>
                                  </Tooltip>
                                </>
                              </p>
                              <small>{pageLanguageContents?.Arrow_Price[11]?.PerPallet}</small>
                            </div>
                            <div className={styles.field}>
                              <NumberInput
                                name="desiredPrice"
                                prefix={"$"}
                                placeholder="$ 0.00"
                                decimalScale={2}
                                maxLength={8}
                                decimalSeparator=","
                                fixedDecimalScale
                                thousandSeparator={true}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-4 col-sm-6">
                          <div className="my-2">
                            <p className={`mb-0 ${styles.lineHeight14}`}>
                              {pageLanguageContents?.Arrow_Price[15]?.PickupPrice}
                              <>
                                <img
                                  id="TooltipCpu"
                                  src={information}
                                  alt="information"
                                  style={{
                                    paddingLeft: "5px",
                                    position: "relative",
                                    top: "-1px",
                                  }}
                                />
                                <Tooltip
                                  placement="right"
                                  isOpen={tooltipOpenCpu}
                                  target="TooltipCpu"
                                  toggle={() =>
                                    setTooltipOpenCpu(!tooltipOpenCpu)
                                  }
                                >
                                  <InfoTitleText>If you choose to utilize the buy now feature, you are required to sell your pallets to the buyer that made the buy now offer. When a buy now offer is received, you will be notified by email and will have two business hours to accept. Your post will be closed on the marketplace and all other offers will be removed.</InfoTitleText>
                                </Tooltip>
                              </>
                            </p>
                            <small>{pageLanguageContents?.Arrow_Price[11]?.PerPallet}</small>
                          </div>
                          <div className={styles.field}>
                            <NumberInput
                              name="cpuPrice"
                              prefix={"$"}
                              placeholder="$ 0.00"
                              decimalScale={2}
                              maxLength={8}
                              decimalSeparator=","
                              fixedDecimalScale
                              thousandSeparator={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mb-7">
                          <div className={styles.field}>
                            <CheckboxInput
                              name="costCheckBox"
                              label={pageLanguageContents?.Arrow_Price[17]?.CheckBox_2}
                              handleSelect={() => { }}
                            />
                          </div>
                        </div>
                      </div>
                    </SectionWrapper>
                    <SectionWrapper className="pt-3">
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_MyPreferences[0]?.Title}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      {bidCloseDateTime(props)}

                      <div className="row" style={{ "margin-top": "-15px" }}>
                        {!editResponse?.isRecurring && !editResponse?.isPostRecurring && (
                          <>
                            {" "}
                            <div className="mt-2 mb-0 col-12">
                              <p className="mb-0">Scheduling Options</p>
                            </div>
                            <>
                              {recurrencePost?.map((value, index) => (
                                <CheckBoxWrapper
                                  className={`${styles.field} col-md-12`}
                                  key={index}
                                  style={{ "margin-top": "-10px" }}
                                >
                                  <CheckboxInput
                                    name={"isPostRecurring" + index}
                                    label={value.label}
                                    handleSelect={(val, label, flag) => {
                                      if (label === recurrencePost[0].label) {
                                        setFieldValue("isPostRecurring1", false);
                                        setRecurrenceFlag(1);
                                        if (flag) requestDateToggleModal();
                                        else setRecurrenceFlag(0);

                                        setRecurrenceTitle("Setup Recurring Post");
                                      } else {
                                        setRecurrenceFlag(0);
                                      }
                                      if (props.values.type === "RELATIVEMONTHLY") {
                                        setRecurrenceStateObj({
                                          type: "MONTHLY",
                                          requestDeliveryDate:
                                            props.values.requestDeliveryDate,
                                        });
                                      } else {
                                        setRecurrenceStateObj({
                                          type: props.values.type,
                                          requestDeliveryDate:
                                            props.values.requestDeliveryDate,
                                        });
                                      }
                                    }}
                                  />

                                  {index === recurrenceFlag - 1 && (
                                    <MaterialTooltip
                                      placement="bottom"
                                      enterTouchDelay={0}
                                      arrow
                                      title={
                                        <>
                                          {props.values.type === "DAILY" && (
                                            <>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[7]?.ToolTipRecType}{" "}
                                                <span>{props.values.type}</span>
                                              </p>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[8]?.ToolTipDays}{" "}
                                                <span>{props.values.interval}</span>
                                              </p>
                                            </>
                                          )}
                                          {props.values.type === "WEEKLY" && (
                                            <>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[9]?.ToolTipType}{" "}
                                                <span>{props.values.type}</span>
                                              </p>
                                            </>
                                          )}
                                          {props.values.type === "MONTHLY" && props.values.monthlyRadio === "Day" && (
                                            <>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[8]?.ToolTipDays}
                                                <span>{props.values.noDay}</span>
                                              </p>
                                              <p><span>{props.values.interval}</span></p>
                                            </>
                                          )}
                                          {props.values.type === "RELATIVEMONTHLY" && props.values.monthlyRadio !== "Day" && (
                                            <>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[12]?.ToolTipDoM}{" "}
                                                <span>{props.values.dayOfWeek}</span>
                                              </p>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[11]?.ToolTipWoM}
                                                <span>{props.values.index}</span>
                                              </p>
                                              <p>
                                                {pageLanguageNeedContents?.Arrow_Delivery_Requirement[10]?.ToolTipEM}{" "}
                                                <span>{props.values.dayOfMonth}</span>
                                              </p>
                                            </>
                                          )}
                                          {props.values.recurrenceRadio === "endAfter" && (
                                            <p>
                                              {pageLanguageNeedContents?.Arrow_Delivery_Requirement[13]?.ToolTipOcc}
                                              <span>{props.values.endAfterOccurrences}</span>
                                            </p>
                                          )}
                                          {props.values.recurrenceRadio !== "endAfter" && (
                                            <p>
                                              {pageLanguageNeedContents?.Arrow_Delivery_Requirement[14]?.ToolTipED}
                                              <span>{moment(props.values.endBy).format(FORMAT)}</span>
                                            </p>
                                          )}
                                        </>
                                      }
                                    >
                                      <img
                                        style={{ marginBottom: "8px", marginLeft: "5px", }}
                                        className={`${styles.recurrenceOnTime} i-icon`}
                                        src={information}
                                        alt="information"
                                      />
                                    </MaterialTooltip>
                                  )}
                                </CheckBoxWrapper>
                              ))}
                            </>
                          </>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-12 mt-2">
                          <div className="my-2">
                            <p>{pageLanguageContents?.Arrow_MyPreferences[2]?.Bid}</p>
                          </div>
                          <div className="row">
                            {bidArr?.map((value, index) => (
                              <div
                                className={`${styles.field} col-md-6 `}
                                key={index}
                              >
                                <Field
                                  component={RadioButton}
                                  name={(props.values.lotsCheckBox && index == 0) ? 'postingRadioDisable' : 'bidAcceptanceMethod'}
                                  id={value.value}
                                  disabled={props.values.lotsCheckBox ? (index == 0 ? true : false) : false}
                                  defaultValue={bidArr[1].value}
                                  onSelect={(e) => { }}
                                  label={
                                    <span>
                                      <span>{value.label}</span>{" "}
                                      {index === 0 ? (
                                        <>
                                          <img
                                            id="TooltipBidAccept"
                                            src={information}
                                            style={{ paddingLeft: "5px", position: "relative", top: "-1px", }}
                                            alt="information"
                                          />
                                          <Tooltip
                                            placement="right"
                                            isOpen={tooltipBidAccept}
                                            target="TooltipBidAccept"
                                            toggle={() => setTooltipBidAccept(!tooltipBidAccept)}
                                          >
                                            <InfoTitleText>Automatically accept highest offer after time close.</InfoTitleText>
                                          </Tooltip>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <p>
                            {pageLanguageContents?.Arrow_MyPreferences[5]?.Community}
                          </p>
                          <div className="row">
                            {postMethodArr?.map((value, index) => (
                              <div
                                className={`${styles.field} col-md-4`}
                                key={index}
                              >
                                <Field
                                  component={RadioButton}
                                  name='postingPlacePreference'
                                  id={value.value}
                                  defaultValue={postMethodArr[0].value}
                                  disabled={((value.value === 'GROUP' && communityGroups?.length < 1) || (value.value === 'GROUP' && props.values.locationType === 'sub')) ? true : false}
                                  label={value.label}
                                  onSelect={(e) => { }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {/* && props.values.locationType === 'main' */}
                      {props.values?.postingPlacePreference === 'GROUP' && props.values.locationType === 'main' && communityGroups?.length > 0 &&
                        <div className="row">
                          <div className="col-12 mb-7">
                            <p>My Community Groups</p>
                            <div className={styles.fieldGroup}>
                              <div className="w-100">
                                {editResponse ?
                                  <>{(multiSelectVal?.length > 0 || (editResponse?.postPreferences?.postingMethod === "MARKET" || props.values?.postingPlacePreference === 'GROUP')) && <MultiSelect
                                    name="postingMethod"
                                    data={communityGroups}
                                    multiSelectVal={multiSelectVal}
                                    // setMultiSelectVal={setMultiSelectVal}
                                    disabled={false}
                                    placeholder={'My Community Groups'}
                                    defaultValueArr={multiSelectVal}
                                  />}</>
                                  : <MultiSelect
                                    name="postingMethod"
                                    data={communityGroups}
                                    multiSelectVal={multiSelectVal}
                                    // setMultiSelectVal={setMultiSelectVal}
                                    disabled={false}
                                    placeholder={'My Community Groups'}
                                    defaultValueArr={[]}
                                  />}
                              </div>
                            </div>
                          </div>
                        </div>}
                      <div className="row">
                        <div className="col-12 mb-7">
                          <div className="my-2">
                            <p>{pageLanguageContents?.Arrow_MyPreferences[11]?.Note}</p>
                          </div>
                          <div>
                            <TextArea
                              name="description"
                              maxLength="500"
                              showErrorMessages={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={styles.footer}>
                        <Button
                          type="app-green-button"
                          handleClick={() => postInventoryClick(props)}
                          disabled={Object.keys(errors).length !== 0}
                        >
                          {pageLanguageContents?.Arrow_MyPreferences[12]?.Button}
                        </Button>
                      </div>
                    </SectionWrapper>
                  </Form>

                  <RequestDateModal
                    isOpen={requestDateModal}
                    toggle={requestDateToggleModal}
                    title={recurrenceTitle}
                    selectedType={props.values.isDeliveryAvailable === "true" ? "DELIVERABLE" : "PICK_UP"}
                    recurrenceType="Inventory"
                    onClickHander={(recurrenceStateObj) => {
                      if (recurrenceStateObj.yesNoBtns === "no") {
                        setRecurrenceFlag(0)
                        setFieldValue("isPostRecurring0", false);
                        setRecurrenceStateObj(INITIAL_STATE);
                      } else {
                        setRecurrenceStateObj(recurrenceStateObj);
                        let requestDeliveryDate = moment(recurrenceStateObj.requestDeliveryDate).format(FORMAT);
                        setRecurrenceStateObj({ requestDeliveryDate: requestDeliveryDate });

                        setRecurrenceStateObj({ type: recurrenceStateObj.type, });

                        setFieldValue("requestDeliveryDate", requestDeliveryDate);
                        setFieldValue("type", recurrenceStateObj.type);
                        if (recurrenceStateObj.type === "DAILY") {
                          setFieldValue("interval", recurrenceStateObj.interval);
                          setFieldValue("dayOfWeek", null);
                          setFieldValue("dayOfMonth", null);
                          setFieldValue("index", null);
                        } else if (recurrenceStateObj.type === "WEEKLY") {
                          setFieldValue("interval", recurrenceStateObj.interval);
                          setFieldValue("dayOfWeek", recurrenceStateObj.dayOfWeek);
                          setFieldValue("dayOfWeek", recurrenceStateObj.dayOfWeek);
                          setFieldValue("daysOfWeek", recurrenceStateObj.daysOfWeek);

                          setFieldValue("dayOfMonth", null);
                          setFieldValue("index", null);
                        } else {
                          setFieldValue("start", recurrenceStateObj.start);
                          setFieldValue("monthlyRadio", recurrenceStateObj.theDayRadio);
                          setRecurrenceStateObj({ type: "MONTHLY" });
                          setRecurrenceStateObj({ theDayRadio: recurrenceStateObj.theDayRadio, });
                          setFieldValue("daysOfWeek", []);
                          if (recurrenceStateObj.theDayRadio === "Day") {
                            setFieldValue("index", null);
                            setFieldValue("dayOfWeek", null);
                            setFieldValue("noDay", recurrenceStateObj.noDay);
                            setFieldValue("interval", recurrenceStateObj.interval);
                            setFieldValue("dayOfMonth", recurrenceStateObj.noDay);
                          } else {
                            setFieldValue("type", "RELATIVEMONTHLY");
                            setFieldValue("interval", null);
                            setFieldValue("index", recurrenceStateObj.index);
                            setFieldValue("dayOfWeek", recurrenceStateObj.daysdropDown);
                            setFieldValue("dayOfMonth", recurrenceStateObj.dayOfMonth);
                          }
                        }
                        setFieldValue("recurrenceRadio", recurrenceStateObj.recurrenceRadio);
                        if (recurrenceStateObj.recurrenceRadio === "endAfter") {
                          setFieldValue("endAfterOccurrences", recurrenceStateObj.endAfterOccurrences);
                          setFieldValue("endBy", null);
                        } else {
                          setFieldValue("endAfterOccurrences", null);
                          setFieldValue("start", recurrenceStateObj.start);
                          setFieldValue("endBy", recurrenceStateObj.endBy);
                        }
                      }
                    }}
                    recurrenceObjState={recurrenceObjState}
                    recurranceDateState={""}
                    pageLanguageContents={pageLanguageNeedContents}
                  />

                  <YesNoModal
                    isOpen={yesNomodal}
                    toggle={yesNoToggleModal}
                    title={""}
                    content={yesNoModalContent}
                    type="inventory"
                    onClickHander={(val) => {
                      if (!val) {
                        yesNoToggleModal();
                        setYesNoActive(true);
                        handleSubmit(props, true);
                      }
                    }}
                    link=""
                  />
                </>
              );
            }}
          </Formik>
        )}
      </>
    );
  };

  const bidCloseDateTime = (props) => {
    return (
      <>
        <div className="row mb-0">
          <div className="col-12 mb-7">
            <div className="my-2">
              <p>
                {pageLanguageContents?.Arrow_MyPreferences[1]?.BidEnd}
                <span className={styles.star}>&#42;</span>
                <>
                  <img
                    id="TooltipBidCloseDate"
                    src={information}
                    style={{ paddingLeft: "5px", position: "relative", top: "-1px", }}
                    alt="information"
                  />
                  <Tooltip
                    placement="right"
                    isOpen={tooltipBidCloseDate}
                    target="TooltipBidCloseDate"
                    toggle={() =>
                      settooltipBidCloseDate(!tooltipBidCloseDate)
                    }
                  >
                    <InfoTitleText>The first available pickup or delivery date that a buyer can choose when making an offer will consider the lead time plus the bid run time.</InfoTitleText>
                  </Tooltip>
                </>
              </p>
            </div>

            <div className="row mb-0">
              {/* For mobile */}
              <div className="col-7 mb-2 mobile-menu">
                <DatePicker
                  name="bidCloseTime"
                  placeholderText="Bid close time"
                  editResponse={editResponse}
                  props={props}
                  type={editResponse ? "editPost" : "Post"}
                  selectedDate={props.values?.bidCloseTime}
                  leadTimeState={''}
                />
              </div>

              <div className="col-4 mb-2 web-view-menu">
                <DatePicker
                  name="bidCloseTime"
                  placeholderText="Bid close time"
                  editResponse={editResponse}
                  props={props}
                  type={editResponse ? "editPost" : "Post"}
                  selectedDate={props.values?.bidCloseTime}
                  leadTimeState={''}
                />
              </div>

              <div className="col-4 mb-0">
                <TimePickerInput
                  name="postLoadBidCloseTime"
                  type="time"
                  prePopulateState={editResponse}
                  editResponse={editResponse}
                  showErrorMessages={true}
                  selectedValue={props?.values?.postLoadBidCloseTime}
                />
              </div>
            </div>
            {recurrenceFlag !== 0 && (
              <p style={{ marginTop: "-8px" }}>
                Bid close date & time will adjust accordingly to the start date
                of each new post.
              </p>
            )}
          </div>
        </div>
      </>
    );
  };

  const uploadImageApi = async (props, specFileUpdatedValue) => {
    if (palletImagesArr) {
      let formDataPalletImages = new FormData();
      for (let i = 0; i < palletImagesArr.length; i++) {
        formDataPalletImages.append("uploadSpecification", palletImagesArr[i]);
      }
      let responseforimages = await dispatch(uploadSpec(formDataPalletImages, token));

      if (responseforimages.status === "SUCCESS") {
        uploadPalletImageArr = responseforimages.payload
        setUploadPalletImageArr(responseforimages.payload)
        handleSubmit(props, false, specFileUpdatedValue);
      }

    } else {
      handleSubmit(props, false, specFileUpdatedValue);
    }
  }

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
    },
  ];
  return (
    <>
      <Helmet title="Sell Pallets on the Marketplace, List Your Inventory | PalletTrader" >
        <meta name="description"
          content="Have pallets to sell? Post your pallet inventory and the on our marketplace. Connect with potential buyers Today!" />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/post-my-pallet-inventory" />
      </Helmet>
      <Layout
        userType="Seller"
        pageType="postInventory"
        topBarViewMobile={"hide"}
      >
        {(loaderVisible || pageLoading) && <Spinner />}
        <div className={styles.postRequirement}>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected={pageLanguageContents?.Breadcrumb[1]?.PalletOffers}
            title=""
          />
          <FormWrapper>
            {localStorage.getItem('accountType') !== 'Guest' && <BlankSection>
              {activePage && (
                <PalletsSidebar
                  activePage={activePage}
                  activeSearch={activeSearch}
                  expandedPallet={expanded}
                />
              )}
            </BlankSection>}
            <FormDiv>
              <div className={styles.headingTitle}>
                <h4>{pageLanguageContents?.Post_Inventory[0]?.Title}</h4>
                <p>{pageLanguageContents?.Post_Inventory[1]?.Description}</p>
              </div>
              {postInventoryFun()}
            </FormDiv>
          </FormWrapper>

          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            alertType="load"
            content={modalContent}
            link={modalLink}
            callBackAlert={() => {
              if (loadSuccessState) {
                let obj = {
                  postType: "PostInventory",
                  type: "palletOffers",
                  activePage: "PostInventory",
                  activeSearch: "Dashboard",
                  expanded: "panel2",
                };
                dispatch({ type: "CREATED_INVENTORY", payload: obj });

                history.push({
                  pathname: "/my-posted-pallet-inventory",
                  //search: "?postType=PostInventory&type=palletOffers&activePage=PostInventory&expanded=panel2",
                });
              }
            }}
          />
          <OkCancelAlertModal
            isOpen={okCancelModal}
            toggle={toggleOkCancelModal}
            alertType="postInventory"
            content={okCancelModalContent}
            callBackAlert={() => {
              postInventoryClick(postLoadData);
            }}
          />
        </div>
      </Layout>
    </>
  );
};
export default PostInventory;

const HeadingWrapper = styled.div`
  position: relative;
  .right-arrow {
    position: absolute;
    left: -33px;
    top: 0;
  }
  @media (max-width: 767px) {
    h6 {
      font-size: 20px !important;
      line-height: 36px !important;
      padding-left: 48px !important;
    }
    .right-arrow {
      max-width: 71px;
    }
  }
`;
const SectionWrapper = styled.div`
  border-radius: 10px;
  padding: 0 33px;
  margin-bottom: 20px;
  color: #191819;
  background: #fff;
  box-shadow: 0 2px 10px 0 #00000029;
  .checkbox-wrapper{
    .checkbox-field {
      margin: 13px 0!important;
    }
  }
  .office-days{
    .checkbox-field {
      margin: 10px 13px 0px 0px !important;
    }
  }
  .select-height {
    min-height: 97px;
  }
  .mb-7 {
    margin-bottom: 7px;
  }
  .mb-15 {
    margin-bottom: 2px;
  }
  p {
    font-size: 17px;
    font-family: "latoregular";
  }  
  .app-input-text{
    margin-bottom: 0px !important;
  }
`;

const FormWrapper = styled.div`
  display: flex;
`;
const BlankSection = styled.div`
  flex: 1;
  max-width: 253px;
  min-width: 253px;
  @media (max-width: 1250px) {
    display: none;
  }
`;
const FormDiv = styled.div`
  flex: 1;
  padding-left: 29px;
  @media (max-width: 1250px) {
    padding-left: 0;
  }
`;
const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  .checkbox-field {
    margin-bottom: 6px;
  }
  .i-icon {
    bottom: 9px;
  }
  .web-only {
    display: block;
  }
  @media (max-width: 768px) {
    .web-only {
      display: none;
    }
  }
`;
const UploadSpec = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: flex-start;
  span {
    white-space: normal;
    margin-top: 2px;
  }
  img {
    margin-right: 5px;
  }
`;
const PostLoaduploadWrapper = styled.div`
  p.error-message-multiple {
    position: unset;
    color: red !important;
    font-style: italic;
    font-size: 12px !important;
    margin-top: 10px;
  }
`;
export const PalletSpecWrapper = styled.div`
  .app-input-text{
    margin-bottom: 0px !important;
  }
`
export const InfoTitleText = styled.div`
  font-size:14px !important;
  text-align:center !important;
  line-height: 18px !important;
`